var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "inputForm",
          attrs: {
            size: "small",
            model: _vm.inputForm,
            disabled: _vm.formReadOnly,
            "label-width": "120px",
          },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 15 } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "变动用户",
                        prop: "user.id",
                        rules: [
                          {
                            required: true,
                            message: "变动用户不能为空",
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c("user-select", {
                        attrs: { limit: 1, value: _vm.inputForm.user.id },
                        on: {
                          getValue: function (value) {
                            _vm.inputForm.user.id = value
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "归属部门",
                        prop: "office.id",
                        rules: [
                          {
                            required: true,
                            message: "归属部门不能为空",
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c("SelectTree", {
                        ref: "office",
                        attrs: {
                          props: {
                            value: "id", // ID字段名
                            label: "name", // 显示名称
                            children: "children", // 子级字段名
                          },
                          url: "/sys/office/treeData?type=2",
                          value: _vm.inputForm.office.id,
                          clearable: true,
                          accordion: true,
                        },
                        on: {
                          getValue: function (value) {
                            _vm.inputForm.office.id = value
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "岗位", prop: "post", rules: [] } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请填写岗位" },
                        model: {
                          value: _vm.inputForm.post,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputForm, "post", $$v)
                          },
                          expression: "inputForm.post",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "性别", prop: "sex", rules: [] } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.inputForm.sex,
                            callback: function ($$v) {
                              _vm.$set(_vm.inputForm, "sex", $$v)
                            },
                            expression: "inputForm.sex",
                          },
                        },
                        _vm._l(
                          _vm.$dictUtils.getDictList("sex"),
                          function (item) {
                            return _c(
                              "el-radio",
                              { key: item.value, attrs: { label: item.value } },
                              [_vm._v(_vm._s(item.label))]
                            )
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "学历", prop: "edu", rules: [] } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请填写学历" },
                        model: {
                          value: _vm.inputForm.edu,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputForm, "edu", $$v)
                          },
                          expression: "inputForm.edu",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "调整原因",
                        prop: "content",
                        rules: [
                          {
                            required: true,
                            message: "调整原因不能为空",
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          placeholder: "请填写调整原因",
                        },
                        model: {
                          value: _vm.inputForm.content,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputForm, "content", $$v)
                          },
                          expression: "inputForm.content",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "现行标准 薪酬档级",
                        prop: "olda",
                        rules: [],
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请填写现行标准 薪酬档级" },
                        model: {
                          value: _vm.inputForm.olda,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputForm, "olda", $$v)
                          },
                          expression: "inputForm.olda",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "现行标准 月工资额",
                        prop: "oldb",
                        rules: [
                          {
                            required: true,
                            message: "现行标准 月工资额不能为空",
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请填写现行标准 月工资额" },
                        model: {
                          value: _vm.inputForm.oldb,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputForm, "oldb", $$v)
                          },
                          expression: "inputForm.oldb",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "现行标准 年薪总额",
                        prop: "oldc",
                        rules: [],
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请填写现行标准 年薪总额" },
                        model: {
                          value: _vm.inputForm.oldc,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputForm, "oldc", $$v)
                          },
                          expression: "inputForm.oldc",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "调整后标准 薪酬档级",
                        prop: "newa",
                        rules: [],
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请填写调整后标准 薪酬档级" },
                        model: {
                          value: _vm.inputForm.newa,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputForm, "newa", $$v)
                          },
                          expression: "inputForm.newa",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "调整后标准 月工资额",
                        prop: "newb",
                        rules: [
                          {
                            required: true,
                            message: "调整后标准 月工资额不能为空",
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请填写调整后标准 月工资额" },
                        model: {
                          value: _vm.inputForm.newb,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputForm, "newb", $$v)
                          },
                          expression: "inputForm.newb",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "调整后标准 年薪总额",
                        prop: "newc",
                        rules: [],
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请填写调整后标准 年薪总额" },
                        model: {
                          value: _vm.inputForm.newc,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputForm, "newc", $$v)
                          },
                          expression: "inputForm.newc",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "月增资",
                        prop: "addNum",
                        rules: [
                          {
                            required: true,
                            message: "月增资不能为空",
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请填写月增资" },
                        model: {
                          value: _vm.inputForm.addNum,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputForm, "addNum", $$v)
                          },
                          expression: "inputForm.addNum",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "执行时间",
                        prop: "exeDate",
                        rules: [
                          {
                            required: true,
                            message: "执行时间不能为空",
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          placeholder: "选择日期时间",
                        },
                        model: {
                          value: _vm.inputForm.exeDate,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputForm, "exeDate", $$v)
                          },
                          expression: "inputForm.exeDate",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "备注信息", prop: "remarks", rules: [] },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          placeholder: "请填写备注信息",
                        },
                        model: {
                          value: _vm.inputForm.remarks,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputForm, "remarks", $$v)
                          },
                          expression: "inputForm.remarks",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }